module.exports = __webpack_public_path__ + "img/error.1efffaea.svg";